import React from "react";
import {formatMoney2} from "utils/moneyHelper";
import {
    StatsGrid,
    StatCard,
    StatIcon,
    StatBadge,
    StatLabel,
    StatValue
} from "../styles/SubCompanyInvoice.styles";
// SVG içindeki fill currentColor olduğu için StatIcon'un tonundaki rengi alır
import {ReactComponent as IssuedAmountIcon} from "../../../public/images/issuedAmount.svg";
import {ReactComponent as UnissuedCodInvoice} from "../../../public/images/UnissuedCodInvoice.svg";
import {ReactComponent as BillCheck} from "../../../public/images/billCheckIcon.svg";

const formatCount = value => (value == null ? "0" : Number(value).toLocaleString("tr-TR"));
const formatAmount = value => formatMoney2({amount: value ?? 0, currency: "TL"});

const IssuedInvoiceIcon = () => <IssuedAmountIcon width="1em" height="1em" />;
const BillCheckIcon = () => <BillCheck width="1em" height="1em" />;
const UnissuedCodInvoiceIcon = () => <UnissuedCodInvoice width="1em" height="1em" />;

const STAT_CONFIG = [
    {
        amountKey: "totalCalculatedInvoiceAmount",
        countKey: "totalCalculatedInvoiceCount",
        label: "Hesaplanan Vigo Kurye Hizmeti Faturası Tutarı",
        icon: BillCheckIcon,
        tone: "calculatedAmount"
    },
    {
        amountKey: "totalIssuedInvoiceAmount",
        countKey: "totalIssuedInvoiceCount",
        label: "Kesilen Vigo Kurye Hizmeti Faturası Tutarı",
        icon: IssuedInvoiceIcon,
        tone: "issuedAmount"
    },
    {
        amountKey: "totalUnissuedCodInvoiceAmount",
        countKey: "totalUnissuedCodInvoiceCount",
        label: "Kesilmesi Beklenen Kapıda Ödeme Tahsilat Faturası Tutarı",
        icon: UnissuedCodInvoiceIcon,
        tone: "pendingAmount"
    }
];

export const SubCompanyInvoiceStats = ({summary}) => (
    <StatsGrid>
        {STAT_CONFIG.map(({amountKey, countKey, label, icon: Icon, tone}) => (
            <StatCard key={amountKey}>
                <StatIcon $tone={tone}>
                    <Icon />
                    <StatBadge title="Fatura sayısı">{formatCount(summary?.[countKey])}</StatBadge>
                </StatIcon>
                <StatValue>{formatAmount(summary?.[amountKey])}</StatValue>
                <StatLabel title={label}>{label}</StatLabel>
            </StatCard>
        ))}
    </StatsGrid>
);
